/**
 * The arenas that ship: every id here has a built asset under `assets/processed/arenas/<id>/`.
 * Online matches draw one from the match seed so the choice is recorded and replayable; practice
 * lets the pilot pick.
 */
import { z } from 'zod';
export const ARENA_IDS = ['foundry', 'dust-basin', 'orbital-dock'];
export const ArenaIdSchema = z.enum(ARENA_IDS);
export const DEFAULT_ARENA_ID = 'foundry';
/** Display names for the lobby (each sidecar carries the same name; a test keeps them equal). */
export const ARENA_NAMES = {
    foundry: 'The Foundry',
    'dust-basin': 'Dust Basin',
    'orbital-dock': 'Orbital Dock',
};
/** One line for the loading screen's arena card. */
export const ARENA_DESCRIPTIONS = {
    foundry: 'A working foundry: molten channels, catwalks and a heat hazard along the rim.',
    'dust-basin': 'An open basin of dunes and wrecks: long sightlines, low cover, boost pads across the sand.',
    'orbital-dock': 'A dark hangar deck: gantries on two levels, lifts on a schedule, steam that hides you.',
};
export function isArenaId(value) {
    return ARENA_IDS.includes(value);
}
/** A deterministic pick from a match seed. */
export function arenaForSeed(seed) {
    const index = Math.abs(Math.trunc(seed)) % ARENA_IDS.length;
    return ARENA_IDS[index] ?? DEFAULT_ARENA_ID;
}
//# sourceMappingURL=registry.js.map